import { render, staticRenderFns } from "./ShareBtn.vue?vue&type=template&id=71bc8671&lang=pug"
import script from "./ShareBtn.vue?vue&type=script&lang=js"
export * from "./ShareBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports